module.exports = __webpack_public_path__ + "img/guihua.17a0ae74.png";